import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const vipEvaluateState = {
  vipEvaluateUI: null,
  vipEvaluateList: null,
  vipEvaluateEffList: null,
};

export const vipEvaluateSlice = createSlice({
  name: "vipEvaluate",
  initialState: vipEvaluateState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    vipEvaluateUIFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipEvaluateUI = action.payload.data;
    },
    vipEvaluateListFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipEvaluateList = action.payload.data;
    },
    vipEvaluateEffListFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipEvaluateEffList = action.payload.data ?? {};
    },
    vipEvaluatePublished: (state) => {
      state.actionsLoading = false;
    },
  },
});
